import { wxShare } from "_lib/utils"
import { getShareInfo } from '_api/wx_share'
import { CLIENT_TYPE } from '../js/global'
class DeepLinkElementManager {
  list = []
  constructor () {
    this.weixinDataPromise = this.getWeixinData()
    this.canUseDeepLink = this.getCanUseDeepLink()
    document.addEventListener('WeixinOpenTagsError', function (e) {
      this.canUseDeepLink = false
      this.updateElements()
    })
  }

  addItem (el) {
    this.list.push(el)
    this.updateElements()
  }

  deleteItem (el) {
    let index = this.list.indexOf(el)
    if (index === -1) return
    this.list.splice(index, 1)
    this.updateElements()
  }

  updateElements () {
    this.list.forEach(el => {
      if (this.canUseDeepLink) {
        el.style.display = 'initial'
      } else {
        el.style.display = 'none'
      }
    })
  }

  launchWxShare (shareConfig) {
    this.weixinDataPromise.then(weixindata => {
      wxShare(weixindata, shareConfig, true)
    })
  }
  getWeixinData () {
    return getShareInfo().then((res) => {
      return res.data.result || {}
    })
  }

  getCanUseDeepLink () {
    if (CLIENT_TYPE === 'maxjia') return false
    // 微信版本号大于 7.0.12 开放标签才可进行 唤醒 app 跳转
    const wechatInfo = window.navigator.userAgent.match(
      /MicroMessenger\/([\d\.]+)/i
    )
    if (!wechatInfo) return false
    let judgewechat = wechatInfo[1].split(".")
    if (judgewechat[0] >= 7 && judgewechat[1] >= 0 && judgewechat[2] >= 12) {
      return true
    } else {
      return false
    }
  }
}
export const deepLinkManager = new DeepLinkElementManager()




export default {
  install (Vue) {
    Vue.directive('deeplink', {
      bind (el, binding, vnode) {
        deepLinkManager.addItem(el)
      },
      unbind (el) {
        deepLinkManager.deleteItem(el)
      }
    })
  }
}